import * as React from 'react';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { CreateAccountV2 } from '../../containers/account/CreateAccountV2';

export const AdminCreateAccountPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<CreateAccountV2 />
		</AdminDashboardPageLayout>
	);
};
